import type { SolicitudDetalle } from "@/lib/types";

export interface SiguientePaso {
  label: string;
  /** Path con `$id` literal · el caller hace navigate con params. */
  to: string;
}

/**
 * Devuelve el "siguiente paso" sugerido para la solicitud según su
 * estado actual. Útil para el CTA destacado en la sidebar derecha del
 * detalle.
 *
 * Función pura · sin React, sin router · testeable directamente.
 */
export function calcularSiguientePaso(
  solicitud: SolicitudDetalle
): SiguientePaso | null {
  switch (solicitud.estado) {
    case "Validado":
      return { label: "Capturar datos generales", to: "/solicitudes/$id/datos-generales" };
    case "CapturandoDatos":
      return { label: "Continuar datos generales", to: "/solicitudes/$id/datos-generales" };
    case "SeleccionandoProveedor":
      return { label: "Seleccionar proveedor", to: "/solicitudes/$id/proveedor" };
    case "Prorrateando":
      return solicitud.cfdis && solicitud.cfdis.length > 1
        ? { label: "Construir prorrateo", to: "/solicitudes/$id/prorrateo-multiple" }
        : { label: "Construir prorrateo", to: "/solicitudes/$id/prorrateo" };
    case "ProvisionalmenteListo":
    case "AdjuntandoDocumentos":
      return { label: "Adjuntar documentos", to: "/solicitudes/$id/documentos" };
    case "ListoParaAutorizacion":
      return { label: "Revisar y enviar", to: "/solicitudes/$id/documentos" };
    default:
      return null;
  }
}
